// removed by extract-text-webpack-plugin
module.exports = {"degreeDistribution":"degreetion_degreeDistribution_1qZHB","degreePie":"degreetion_degreePie_325zW","recruitment":"degreetion_recruitment_3fJsJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/personnelMessage/degreetion.scss
// module id = 1534
// module chunks = 0